import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isMultiple", "isReadonly", "allowClear", "onlyActive", "placeholder"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { WarningOutlined } from '@ant-design/icons';
import { Select, Space, Typography } from 'antd';
import { RateStatusType } from 'core/client';
import { Colors } from 'core/interfaces/variables.types';
import { getMileageRatesStore } from 'core/modules/rates/rates-mileage.store';
import { formatRate } from 'core/utils/formatter/rate';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { sanitizeAll } from '../../../utils/sanitize';
import { RateStatusIcon } from '../StatusIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Renders a select to select report rate(s). */
export var MileageRateSelect = function MileageRateSelect(_ref) {
  var isMultiple = _ref.isMultiple,
      isReadonly = _ref.isReadonly,
      allowClear = _ref.allowClear,
      onlyActive = _ref.onlyActive,
      placeholder = _ref.placeholder,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getMileageRatesStore = getMileageRatesStore(),
      mileageRates = _getMileageRatesStore.mileageRates;

  var values = onlyActive ? mileageRates.filter(function (it) {
    return [RateStatusType.Active, RateStatusType.Decommissioned].includes(it.status);
  }) : mileageRates;
  var unknownValue = props.value && !Array.isArray(props.value) && !values.some(function (it) {
    return it.id === props.value;
  });
  return /*#__PURE__*/_jsxs(Container, _objectSpread(_objectSpread({}, props), {}, {
    mode: isMultiple ? 'multiple' : undefined,
    allowClear: allowClear,
    bordered: !isReadonly,
    disabled: isReadonly,
    showSearch: true,
    filterOption: function filterOption(input, option) {
      return sanitizeAll(option.title).includes(sanitizeAll(input));
    },
    placeholder: placeholder,
    children: [values.map(function (reportRate) {
      return /*#__PURE__*/_jsx(Select.Option, {
        value: reportRate.id,
        title: "".concat(reportRate.name),
        disabled: onlyActive && reportRate.status !== RateStatusType.Active,
        children: /*#__PURE__*/_jsxs(OptionContent, {
          size: "small",
          children: [onlyActive && reportRate.status !== RateStatusType.Active && /*#__PURE__*/_jsx(RateStatusIcon, {
            status: reportRate.status
          }), /*#__PURE__*/_jsx("span", {
            children: reportRate.name
          }), /*#__PURE__*/_jsxs(Typography.Text, {
            className: "subtle",
            children: ["(", formatRate(reportRate.perKm), "/km)"]
          })]
        })
      }, reportRate.id);
    }), unknownValue && /*#__PURE__*/_jsx(Select.Option, {
      value: props.value,
      title: 'settings.mileageRates.unknown',
      disabled: true,
      children: /*#__PURE__*/_jsxs(Space, {
        children: [/*#__PURE__*/_jsx(WarningOutlined, {
          style: {
            color: Colors.orange[6]
          }
        }), /*#__PURE__*/_jsx("span", {
          children: t('settings.mileageRates.unknown')
        })]
      })
    })]
  }));
}; // Styles

var Container = styled(Select).withConfig({
  displayName: "MileageRateSelect__Container",
  componentId: "sc-ix8mw3-0"
})([""]);
var OptionContent = styled(Space).withConfig({
  displayName: "MileageRateSelect__OptionContent",
  componentId: "sc-ix8mw3-1"
})(["align-items:center;justify-content:center;.subtle{opacity:0.8;font-size:0.8em;}"]);